export const MEETING_TYPES = {
  MEETING: "meeting",
  TRANSITION_MEETING: "transition_meeting",
  GROUP_MEETING: "group_meeting",
} as const;

export type MeetingType = (typeof MEETING_TYPES)[keyof typeof MEETING_TYPES];
